// chemoAdministrationSchema.js
import * as Yup from "yup";
import REGEXS from "../utils/regex";

export const chemoAdministrationSchema = Yup.object().shape({
    doctorName: Yup.string()
        .required("Doctor name is required")
        .matches(
            REGEXS.alplabhets,
            "Doctor name must contain only letters and spaces"
        ),
    // premedicationDetails: Yup.array().of(
    //     Yup.object().shape({
    //         drugType: Yup.string().required("Drug type is required"),
    //         drugName: Yup.string().required("Drug name is required"),
    //         doseAdministered: Yup.string().required("Dose is required"),
    //         administrationRoute: Yup.string().required("Route is required"),
    //     })
    // ),
});